type AddressInfo = {
  prefecture: string;
  city: string;
  block: string;
  building: string | null | undefined;
  name: string;
};

const createQueryForMap = (address: AddressInfo): string => {
  let addressText = `${address.prefecture}${address.city}${address.block}`;
  // 番地とビル名がつながらないようスペースを入れる
  if (address.building) {
    addressText += ` ${address.building}`;
  }
  addressText += `,${address.name}`;
  return encodeURIComponent(addressText);
};

export const createGoogleMapUrl = (address: AddressInfo): string => {
  const apiKey = process.env.GOOGLE_API_KEY;
  const query = createQueryForMap(address);
  return `https://www.google.com/maps/embed/v1/place?key=${apiKey}&language=ja&q=${query}`;
};

export const createGoogleMapAppUrl = (address: AddressInfo): string => {
  const query = createQueryForMap(address);

  // see: https://developers.google.com/maps/documentation/urls/get-started#search-action
  return `https://www.google.com/maps/search/?api=1&query=${query}`;

  // if you need to launch AppleMap App page below will help you
  // https://developer.apple.com/library/archive/featuredarticles/iPhoneURLScheme_Reference/MapLinks/MapLinks.html
};
